import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@config/axios/axios.config';
import { paths } from '@common/types';

const profileAvatarRequest = async () => {
  const response = axiosInstance.get<Blob>(`/profile/avatar.webp`, {
    responseType: 'blob',
    headers: {
      Accept: 'image/webp,image/apng,image/*,*/*;q=0.8',
      'Content-Type': 'image/webp',
    },
  });

  const data = (await response).data;

  return URL.createObjectURL(data);
};

export const useProfileAvatarQuery = () => {
  const query = useQuery({
    queryKey: ['profileAvatar'],
    queryFn: () => profileAvatarRequest(),
  });

  return query;
};

const ownProfileRequest = async () => {
  const response =
    axiosInstance.get<
      paths[`/profile`]['get']['responses']['200']['content']['application/json']
    >(`/profile`);

  return await response.then(({ data }) => data);
};

export const useOwnProfileQuery = () => {
  const query = useQuery({
    queryKey: ['profile', 'self'],
    queryFn: () => ownProfileRequest(),
    refetchInterval: 30_000,
  });

  return query;
};
